/**
 * Strips optional `{` `}` wrappers from a GUID string (common in Salesforce exports).
 */
export function stripGuidBraces(s: string): string {
  let x = s.trim();
  if (x.startsWith('{') && x.endsWith('}')) {
    x = x.slice(1, -1).trim();
  }
  return x;
}

/**
 * Normalizes a client account GUID for comparison (deep links, session lookup).
 *
 * @param raw Value from query params or API; null/blank returns null.
 * @returns Lowercase trimmed GUID without braces, or null when not usable.
 */
export function normalizeClientGuid(raw: string | null | undefined): string | null {
  if (raw == null) {
    return null;
  }
  const normalized = stripGuidBraces(raw).toLowerCase();
  return normalized.length > 0 ? normalized : null;
}
